
import { defineComponent, inject, onMounted, reactive, toRefs } from "vue";
import NumberIcon from "@/components/atomics/NumberIcon.vue";
import ValidationTextField from "@/components/atomics/ValidationTextField.vue";
export default defineComponent({
  name: "SideAccountVars",
  components: {
    NumberIcon,
    ValidationTextField,
  },
  props: {
    components: { type: Object, default: {} as never },
    contractName: { type: String, default: "" },
  },
  emits: ["onChangeTab", "selectObj", "targetPage"],
  setup(props) {
    const isMobile = inject("isMobile");
    const state = reactive({
      accountVars: {} as any,
    });

    onMounted(() => {
      state.accountVars = props.components;
    });

    return { ...toRefs(state), isMobile };
  },
});
